import { DoctorOverview } from "@/types";
import { Box, Button, Card, CardBody, CardFooter, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { CalendarCog } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";

interface DoctorCardViewProps {
  doc: DoctorOverview;
}

const DoctorCardView = ({ doc }: DoctorCardViewProps) => {
  const navigate = useNavigate();
  
  const imageUrl = doc.image?.file_url || "/assets/img/profile.jpg";
  
  const formatAvailabilityDate = () => {
    if (!doc.next_available_date) return "N/A";
    
    try {
      const date = parseISO(doc.next_available_date);
      return format(date, 'EEE, dd MMM yyyy');
    } catch (error) {
      return "N/A";
    }
  };
  
  const departmentName = typeof doc.department_id === 'string' 
    ? doc.department_id 
    : doc.department_id?.department || "No Department";
  
  return (
    <Card
      className="cursor-pointer"
      key={doc.id}
      direction={{ base: "column", sm: "row" }}
      onClick={() => navigate(`/profile/${doc.id}`)}
      overflow="hidden"
      variant="outline"
      h="140px"
    >
      <Box className="w-2/5" display="flex" alignItems="center" justifyContent="center" pl={2} pr={1} py={1}>
        <Image 
          objectFit="cover" 
          w="120px" 
          h="120px" 
          rounded="md" 
          src={imageUrl}
          alt={doc.user_fullname} 
          fallbackSrc="/assets/img/profile.jpg"
        />
      </Box>

      <Stack p={2} className="w-3/5" spacing={2} justifyContent="space-between">
        <CardBody p={0} display="flex" flexDirection="column" gap={2}>
          <Box lineHeight="1">
            <Heading size="sm" mb="2px">
              {doc.user_fullname}
            </Heading>
            <Text as="span" color="gray" fontSize="xs" display="block">
              {departmentName}
            </Text>
          </Box>
          <Text fontSize="xs" color="gray.600">
            Available : {formatAvailabilityDate()}
          </Text>
        </CardBody>

        <CardFooter p={0}>
          <Button variant="solid" rounded="md" minW="32px" w="32px" h="32px" p={0} bg="white" className="border">
            <CalendarCog size={16} />
          </Button>
        </CardFooter>
      </Stack>
    </Card>
  );
};

export default DoctorCardView;